module.exports = __webpack_public_path__ + "foot_img.png?2ad9854e2581e84542db0ff0a4a5c8d4";